module.exports = __webpack_public_path__ + "static/img/78-3.1586aee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/78-3.jpg
// module id = qJlG
// module chunks = 0